import React from 'react';
import { Lightbulb, Phone, Mail, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="w-full border-t border-border bg-background py-14" data-id="element-50" data-mp="3ggar7wn6mf5z">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-51" data-mp="32o48c2sn9u2u">
        <div className="grid gap-10 md:grid-cols-3" data-id="element-52" data-mp="32lrlpcbxyvjg">
          <div data-id="element-53" data-mp="36oo5h6d7wxoz">
            <div className="flex items-center gap-2" data-id="element-54" data-mp="36q94b86kf2sn">
              <Lightbulb className="h-6 w-6 text-accent" aria-hidden="true" data-id="element-55" data-mp="3ufa4k858v7mu" />
              <span className="font-display text-lg text-foreground" data-id="element-56" data-mp="3ud7h9vvh7slt">
                Outdoor <span className="text-accent" data-id="element-57" data-mp="37xx4ku5y8k4">Landscape</span> Lighting
              </span>
            </div>
            <p className="mt-4 max-w-xs leading-relaxed text-muted-foreground" data-id="element-58" data-mp="3lggc8tyy53f3">
              Custom outdoor landscape lighting design, installation, and repair serving
              Gilbert and the Arizona East Valley.
            </p>
          </div>

          <div data-id="element-59" data-mp="2eyjq5m4bf0um">
            <h3 className="font-display text-lg text-foreground" data-id="element-60" data-mp="2ez1l8ff8r90y">Contact</h3>
            <ul className="mt-4 space-y-3 text-muted-foreground" data-id="element-61" data-mp="3l8qupznvcbpc">
              <li data-id="element-62" data-mp="3lbdaunotrzj6">
                <a href="tel:+14805550147" className="flex items-center gap-2 transition-colors hover:text-accent" data-id="element-63" data-mp="3gapf5opniuim">
                  <Phone className="h-4 w-4 text-accent" aria-hidden="true" data-id="element-64" data-mp="3v7zvpch5iql7" />
                  (480) 555-0147
                </a>
              </li>
              <li data-id="element-65" data-mp="3qaq0fg72zkpg">
                <a href="mailto:info@outdoorlandscapelightingaz.com" className="flex items-center gap-2 transition-colors hover:text-accent" data-id="element-66" data-mp="830iphfda2zy">
                  <Mail className="h-4 w-4 text-accent" aria-hidden="true" data-id="element-67" data-mp="335slg3f1hfy" />
                  info@outdoorlandscapelightingaz.com
                </a>
              </li>
              <li className="flex items-center gap-2" data-id="element-68" data-mp="ct75dbqbjdfk">
                <MapPin className="h-4 w-4 text-accent" aria-hidden="true" data-id="element-69" data-mp="cuiii25nlxjc" />
                Gilbert, Arizona
              </li>
            </ul>
          </div>

          <div data-id="element-70" data-mp="mspqhvhyt597">
            <h3 className="font-display text-lg text-foreground" data-id="element-71" data-mp="mt7q923u61lv">Quick Links</h3>
            <ul className="mt-4 space-y-3 text-muted-foreground" data-id="element-72" data-mp="tvw9ald1dni3">
              <li data-id="element-73" data-mp="yu7ictvibtz9"><a href="#services" className="transition-colors hover:text-accent" data-id="element-74" data-mp="yty0xuoj2v56">Services</a></li>
              <li data-id="element-75" data-mp="13tke644cwbdz"><a href="#why-us" className="transition-colors hover:text-accent" data-id="element-76" data-mp="13tkclzopk3bv">Why Us</a></li>
              <li data-id="element-77" data-mp="18jqznv3knfs0"><a href="#gallery" className="transition-colors hover:text-accent" data-id="element-78" data-mp="18jr17zj7znu4">Gallery</a></li>
              <li data-id="element-79" data-mp="1cluormj5yivr"><a href="#reviews" className="transition-colors hover:text-accent" data-id="element-80" data-mp="1clun7i3imatn">Reviews</a></li>
              <li data-id="element-81" data-mp="1hkfg0wgfts82"><a href="#contact" className="transition-colors hover:text-accent" data-id="element-82" data-mp="1hkfhl0w360a6">Free Quote</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-border pt-6 text-center text-sm text-muted-foreground" data-id="element-83" data-mp="1mkbhop1nx7kg">
          © {new Date().getFullYear()} Outdoor Landscape Lighting AZ. All rights reserved.
        </div>
      </div>
    </footer>;
}